import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PlentiCalculator } from "../components/PlentiCalculator";
import * as Icons from "lucide-react";
import { toast } from "sonner";

export default function Plenti() {
  const { user } = useAuth();
  const [config, setConfig] = useState(null);
  const load = () => api.get("/plenti/config").then((r) => setConfig(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const isAdmin = ["super_admin", "admin"].includes(user?.role);
  const publicLink = `${window.location.origin}/plenti`;

  return (
    <div className="p-4 sm:p-6 max-w-[1400px] mx-auto" data-testid="plenti-page">
      <div className="flex flex-wrap items-center gap-3 mb-1">
        <Icons.Calculator className="text-secondary" size={26} />
        <h1 className="text-2xl font-head font-bold">Plenti calculation</h1>
        <button onClick={() => { navigator.clipboard?.writeText(publicLink); toast.success("Public link copied"); }}
          data-testid="plenti-copy-link" title={publicLink}
          className="ml-auto inline-flex items-center gap-1.5 px-3 py-2 rounded-md border border-border text-sm font-semibold hover:bg-muted">
          <Icons.Link2 size={15} /> Copy public link
        </button>
        <a href={publicLink} target="_blank" rel="noopener noreferrer" data-testid="plenti-open-link"
          className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md border border-border text-sm font-semibold hover:bg-muted">
          <Icons.ExternalLink size={15} /> Open outside CRM
        </a>
      </div>
      <p className="text-sm text-muted-foreground mb-6">Reverse-calculate the amount to enter on the Plenti portal, with the customer's monthly repayment.</p>
      {config ? <PlentiCalculator config={config} editable={isAdmin} onConfigSaved={load} />
        : <div className="text-muted-foreground">Loading…</div>}
    </div>
  );
}
